import { ChangeDetectionStrategy, Component, HostBinding, Signal } from '@angular/core';

import { BetslipConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { Store, createSelector } from '@ngrx/store';
import { EpcotConfigService, EpcotModule } from 'packages/sports/web/app/src/common/epcot-config.service';
import { NumpadService } from 'packages/sports/web/app/src/numpad/numpad.service';
import { BehaviorSubject } from 'rxjs';

import { IBetslipRootState } from '../../../../base/store/state';
import { BetslipType } from '../../../../core/betslip-type';
import { BETSLIP_TYPE_PROVIDER } from '../../../../digital/services/betslip-type-provider.service';
import { betslipPicksListSelector } from '../../../picks/selectors';
import BaseComboBetComponent from '../base-combo-bet.component';

export const selectShowMainComboContainer = createSelector(betslipPicksListSelector, (picksList) => picksList.length > 1);

@Component({
    selector: 'bs-combo-bet-linear',
    templateUrl: './combo-bet-linear.component.html',
    styleUrls: ['./combo-bet-linear.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [NumpadService, { provide: BETSLIP_TYPE_PROVIDER, useValue: new BehaviorSubject(BetslipType.Combo).asObservable() }],
    standalone: false,
})
export default class ComboBetLinearComponent extends BaseComboBetComponent {
    @HostBinding('class.combo-bet-container') hostCssClass = true;

    readonly isEpcotEnabled: boolean;
    readonly isModuleCollapsible: boolean;
    readonly comboHeaderTitle: string;
    readonly showBetBuilderComboList: boolean;
    readonly showMainComboContainer: Signal<boolean>;

    constructor(
        store: Store<IBetslipRootState>,
        public sitecore: Sitecore,
        betslipConfig: BetslipConfig,
        epcotConfigService: EpcotConfigService,
    ) {
        super(store);

        this.comboHeaderTitle = sitecore.betslip.linear.ParlaysHeader;
        this.isEpcotEnabled = epcotConfigService.isEnabled(EpcotModule.Betslip);

        this.isModuleCollapsible = betslipConfig.isLinearCollapsibleModulesEnabled;
        this.showBetBuilderComboList = !betslipConfig.isLinearSeparateBetBuilderModuleEnabled;

        this.showMainComboContainer = store.selectSignal(selectShowMainComboContainer);
    }
}
